
const FUNCTION_URL = process.env.REACT_APP_UNSPLASH_URL || "";
const ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isConfigured = () => Boolean(FUNCTION_URL);

const cache = new Map();
const CACHE_TTL = 10 * 60 * 1000;

async function call(body) {
  const res = await fetch(FUNCTION_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json", Authorization: `Bearer ${ANON_KEY}` },
    body: JSON.stringify(body),
  });
  const data = await res.json().catch(() => ({}));
  return { ok: res.ok, data };
}

export async function searchPhotos(query, count = 12) {
  if (!FUNCTION_URL) return { ok: false, error: "Unsplash is not switched on yet." };

  const key = `${String(query).trim().toLowerCase()}::${count}`;
  const hit = cache.get(key);
  if (hit && Date.now() - hit.at < CACHE_TTL) return { ok: true, photos: hit.photos, cached: true };

  try {
    const { ok, data } = await call({ action: "search", query, count });
    if (!ok || !data?.photos) {
      return { ok: false, error: data?.error || "Could not search Unsplash." };
    }
    cache.set(key, { at: Date.now(), photos: data.photos });
    return { ok: true, photos: data.photos };
  } catch (err) {
    console.warn("[whiteboard] unsplash search failed:", err?.message || err);
    return { ok: false, error: "Could not reach Unsplash." };
  }
}

export function trackDownload(downloadLocation) {
  if (!FUNCTION_URL || !downloadLocation) return;
  call({ action: "track", downloadLocation }).catch(() => {});
}

export function attributionFor(photo) {
  return {
    photographer: photo.photographer,
    profileUrl: photo.profileUrl,
    photoUrl: photo.photoUrl,
    source: "Unsplash",
  };
}

const unsplashService = { searchPhotos, trackDownload, attributionFor, isConfigured };
export default unsplashService;
